export const METRIC_VALUE_KIND = {
  COUNT: 'COUNT',
  RATE: 'RATE',
  PRICE: 'PRICE',
  COMPACT_PRICE: 'COMPACT_PRICE',
  DURATION: 'DURATION',
} as const;
